__turbopack_context__.v({
  "body": "ArticlePageBlok-module__OGsSqq__body",
  "intro": "ArticlePageBlok-module__OGsSqq__intro",
  "root": "ArticlePageBlok-module__OGsSqq__root",
});
